import { ClientDetailModel, ClientProfileDetailModel } from 'lemunzo-api';

/**
 * Unifies evaluation of whether a client profile is locked or not.
 * Lock state is derived as inverse of API-provided editability.
 * @param clientProfile the client profile to be evaluated
 */
export function clientProfileIsLocked(
    clientProfile: ClientDetailModel
): boolean {
    return isProfileLocked(clientProfile.isEditable);
}

/**
 * Unifies evaluation of whether a client profile is locked or not.
 * Lock state is derived as inverse of API-provided editability.
 * @param clientProfile the client profile to be evaluated
 */
export function clientProfileDetailIsLocked(
    clientProfile: ClientProfileDetailModel
): boolean {
    return isProfileLocked(clientProfile.isEditable);
}

function isProfileLocked(isEditable: boolean): boolean {
    return !isEditable;
}
